import { useGet, useQueryWithErrorHandling } from '@app/sdk';

function useAccountConfigurationDataService() {
  const get = useGet(true, "ams");

  function getAvailablePaymentDays(productId: string) {
    return get<{
      value: AvailablePaymentDay[];
    }>(`/api/proxy/ams/account-configuration-data-service/products/${productId}/available-payment-days`);
  }

  return {
    getAvailablePaymentDays,
  };
}

export function useGetAvailableDays({productId}: {productId:string}) {
  const { getAvailablePaymentDays } = useAccountConfigurationDataService();
  return useQueryWithErrorHandling({
    queryKey: ['getAvailablePaymentDays', productId],
    queryFn: () => getAvailablePaymentDays(productId).then((days) => days.value),
    enabled: !!productId,
  });

}